import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles(
  {
    root: {},
    sizeItemWrapper: {
      marginBottom: Spacings.s64,
    },
    sizeItemsTitle: {
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.bold,
      lineHeight: LineHeights.l24,
    },
    carouselItem: {
      '&  [class*="carouselContent"]': {
        padding: Spacings.s16,
        '@media screen and (max-width: 768px)': {
          padding: Spacings.s12,
          gap: 12,
          '&  [class*="slide"]': {
            flexShrink: 'inherit',
          },
        },
      },
      '&  [class*="contentWrapper"]': {
        margin: `-16px`,
        '@media screen and (max-width: 768px)': {
          margin: Spacings.s0,
        },
      },
    },
    sizeItemHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: Spacings.s24,
      '& span': {
        fontSize: FontSizes.s14,
        fontWeight: FontWeights.semibold,
        lineHeight: LineHeights.l20,
      },
    },
    itemWrapper: {
      marginTop: Spacings.s24,
      marginBottom: Spacings.s72,
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      '@media screen and (max-width: 425px)': {
        padding: Spacings.s10,
      },
    },
  },
  {
    name: 'sizes-carousel',
  },
);

export default useStyles;
